import {configRepository} from "@/service/repository/configRepository";

const state = {
    websocketUrl: null,
    websocketPort: null,
	wePassUrl: null,
	weWelcomUrl: null,
	apiUrl: null
};

const getters = {
	websocketUrl(state) {
		return state.websocketUrl;
	},
	websocketPort(state) {
		return state.websocketPort;
	},
	weWelcomUrl(state) {
		return state.weWelcomUrl;
	},
	wePassUrl(state) {
		return state.wePassUrl;
	},
	/** Base URL for wewelcom backend (e.g. https://api.wewelcom.io). Use for /world/* assets and API. */
	apiUrl(state) {
		return state.apiUrl || 'https://api.wewelcom.io';
	}
};

const mutations = {
	initConfig(state, payload){
		console.log("Estableciendo la configuración del servidor", payload)

		state.websocketUrl = payload.websocket_url;
		state.websocketPort = payload.websocket_port;
		state.wePassUrl = payload.wepass_url;
		state.weWelcomUrl = payload.wewelcom_url;
		state.apiUrl = payload.api_url || null;
	},
};

const actions = {
	async loadSystemConfig({ commit }) {
		try {
			const config = await configRepository.loadSystemConfig();
			commit('initConfig', config);
		} catch (error) {
			console.error("Failed to fetch system config", error);
		}
	},
}

export default {
    namespaced: true,
    state,
    mutations,
	actions,
	getters
};
